var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipmentMoveBl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,14.6H15v-9H3v3.7c1.1-0.7,2.4-1.2,3.8-1.2C10.5,8.1,13.5,11,13.6,14.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17,9.6 17,12.6 21.2,12.6 19,9.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,15.6c-0.3,0-0.5,0.1-0.7,0.3S17,16.3,17,16.6s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7C18.5,15.7,18.3,15.6,18,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20,7.6h-3v-4H3c-0.5,0-1,0.2-1.4,0.6S1,5,1,5.6v5.8c0.5-0.8,1.2-1.6,2-2.1V5.6h12v9h-1.4c0,0.1,0,0.2,0,0.3 c0,0.6-0.1,1.2-0.2,1.7H15c0,0.8,0.3,1.5,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9s0.9-1.3,0.9-2.1h2v-5L20,7.6z  M18.7,17.3c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3 s0.5,0.1,0.7,0.3s0.3,0.4,0.3,0.7S18.9,17.1,18.7,17.3z M17,12.6v-3h2l2.2,3H17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,14.6c-0.1-3-2.6-5.3-5.5-5.3c-1.2,0-2.2,0.4-3.1,1c-0.7,0.5-1.2,1-1.6,1.7c-0.5,0.8-0.8,1.8-0.8,2.9 c0,3.1,2.5,5.6,5.6,5.6c2.6,0,4.6-1.8,5.3-4.1c0.1-0.5,0.2-0.9,0.2-1.4C12.3,14.8,12.4,14.7,12.4,14.6z M6.8,10l2.1,2.1l-0.7,0.7 l-0.9-0.9v2h-1v-2l-0.9,0.9l-0.7-0.7L6.8,10z M4,16.9l-2-2l2-2l0.7,0.7l-0.9,0.9h2v1h-2l0.9,0.9L4,16.9z M6.8,19.7l-2.1-2.1L5.4,17 l0.9,0.9v-2h1v2L8.2,17l0.7,0.7L6.8,19.7z M9.6,16.9l-0.7-0.7l0.9-0.9h-2v-1h2l-0.9-0.9l0.7-0.7l2.1,2.1L9.6,16.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentMoveBl);
export default __webpack_public_path__ + "static/media/shipment-move-bl.d432b7d791d1dd10df4a2b8d11e11dbf.svg";
export { ForwardRef as ReactComponent };